import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import GeneralPage from '../general/page';

export default function HotelsPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('tab') !== 'hotels') {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('tab', 'hotels');
      setSearchParams(newParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return <GeneralPage />;
}
